import {Unit} from '../dashboard/monitoring/unit';
import {divIcon, LatLng} from 'leaflet';
import {UnitMarker} from './leaflet/UnitMarker';
import {mapPane} from './models/map-pane.models';

export class MapHelper {
  static createUnitMarker(unit: Unit) {
    const icon = MapHelper.getUnitIcon(unit);

    const m = new UnitMarker(
      new LatLng(unit.lastMsgUnit.lat, unit.lastMsgUnit.lon),
      {
        icon: icon,
        pane: mapPane.MARKER,
        unit_id: unit.id,
        charge: parseInt(unit.charge, 10),
        status_connection: unit.status_connection,
        status_order: unit.status_order
      }
    );
    m.bindTooltip(unit.name, {direction: 'bottom', permanent: true, opacity: 1});
    return m;
  }

  static getUnitIconClass(unitTypeName: string) {

    const unitTypeClass = {
      [Unit.UNIT_TYPE_ELECTRIC_SCOOTER]: 'map-unit-icon-electric-scooter',
      [Unit.UNIT_TYPE_ELECTRIC_BIKE]: 'map-unit-icon-electric-bike',
      [Unit.UNIT_TYPE_BIKE]: 'map-unit-icon-bike',
      [Unit.UNIT_TYPE_VELOMOBILE]: 'map-unit-icon-velomobile',
      [Unit.UNIT_TYPE_CAR]: 'map-unit-icon-car',
      [Unit.UNIT_TYPE_REAL_ESTATE_RENT]: 'map-unit-icon-apartment',
      [Unit.UNIT_TYPE_REAL_ESTATE_PURCHASE]: 'map-unit-icon-apartment',
      [Unit.UNIT_TYPE_TRACKER]: 'map-unit-icon-tracker',
      [Unit.UNIT_TYPE_BABY_CARRIAGE]: 'map-unit-icon-baby_carriage',
      [Unit.UNIT_TYPE_ELECTRIC_QUAD_BIKE]: 'map-unit-icon-electric_quad_bike',
      [Unit.UNIT_TYPE_TRAILER]: 'map-unit-icon-trailer',
      [Unit.UNIT_TYPE_TRICYCLE]: 'map-unit-icon-tricycle',
      [Unit.UNIT_TYPE_CHARGING]: 'map-unit-icon-charging',
      [Unit.UNIT_TYPE_ELECTRIC_MOPED]: 'map-unit-icon-electric-moped',
      [Unit.UNIT_TYPE_BOAT]: 'map-unit-icon-boat',
      [Unit.UNIT_TYPE_IOT]: 'map-unit-icon-iot',
      [Unit.UNIT_TYPE_TRIKE]: 'map-unit-icon-trike',
      [Unit.UNIT_TYPE_ELECTRIC_SNOW_SCOOTER]: 'map-unit-icon-electric-snow-scooter',
    };
    unitTypeClass[Unit.UNIT_TYPE_MECHANICAL_BICYCLE_WITHOUT_IOT] = unitTypeClass[Unit.UNIT_TYPE_BIKE];
    unitTypeClass[Unit.UNIT_TYPE_ELECTRIC_BICYCLE_WITHOUT_IOT] = unitTypeClass[Unit.UNIT_TYPE_ELECTRIC_BIKE];
    unitTypeClass[Unit.UNIT_TYPE_ELECTRIC_BICYCLE_WITH_IOT] = unitTypeClass[Unit.UNIT_TYPE_ELECTRIC_BIKE];
    return unitTypeName in unitTypeClass ? unitTypeClass[unitTypeName] : unitTypeClass[Unit.UNIT_TYPE_ELECTRIC_SCOOTER];
  }

  static getUnitIcon(unit: Unit) {
    let chargeClass = 'charge-level ';
    const charge = unit.charge ? parseInt(unit.charge, 10) : 0;
    if (Unit.chargeIsAlarm(unit)) {
      chargeClass += ' charge-state-low-secondary';
    } else if (Unit.chargeIsWarning(unit)) {
      chargeClass += ' charge-state-middle_warning-secondary';
    } else if (Unit.chargeIsOk(unit)) {
      chargeClass += ' charge-state-middle-secondary';
    } else if (unit.unitModel && unit.unitModel.unit_type_name === 'real_estate_purchase') {
      chargeClass = '';
    } else {
      chargeClass += ' charge-state-high-secondary';
    }
    const unitIconClass = MapHelper.getUnitIconClass(unit.unitModel.unit_type_name);
    let unitStatusClass = '';
    switch (unit.status_connection) {
      case Unit.STATUS_CONNECTION_OFFLINE:
        unitStatusClass = 'status-offline';
        break;
      case Unit.STATUS_CONNECTION_ONLINE:
        unitStatusClass = 'status-online';
        break;
      case Unit.STATUS_CONNECTION_ONLINE_RECENTLY:
        unitStatusClass = 'status-online-recently';
        break;
      case Unit.STATUS_CONNECTION_ONLINE_LATELY:
        unitStatusClass = 'status-online-lately';
        break;
    }
    if (unit.unitModel && unit.unitModel.unit_type_name === 'real_estate_purchase') {
      switch (unit['flatStatus']) {
        case 'flat-rejected':
        case'flat-on-moderation':
        case 'in_creating_process':
          unitStatusClass = 'status-offline';
          break;
        case 'free':
        case 'has_active_booking':
        case 'booked':
        case 'flat-confirmed':
          unitStatusClass = 'status-online';
          break;
      }
    }
    const unitStatusOrderClass = 'order-status icon icon-unit-card icon-unit-card-unit-order-' + unit.status_order_grid;

    const icon = divIcon({
      className: 'map-unit-icon ' + unitIconClass + ' ' + unitStatusClass,
      html: '<div class="' + chargeClass + '"></div><div class="order-status ' + unitStatusOrderClass + '"></div>',
      iconSize: [44, 40],
      iconAnchor: [22, 40],
      shadowSize: [0, 0]
    });
    return icon;
  }

  static getNearestTrackCoords(currentLat, currentLon, layerLatLngs, layerLength) {

    let tempDistance;
    const resultCoords = [];

    for (let item = 0; item < layerLength; item++) {

      if (layerLength - 1 !== item) {

        // Точка A
        const pointA = layerLatLngs[item];

        // Точка B
        const pointB = layerLatLngs[item + 1];

        // координаты точки A
        const pointAx = layerLatLngs[item].lat;
        const pointAy = layerLatLngs[item].lng;

        // координаты точки B
        const pointBx = layerLatLngs[item + 1].lat;
        const pointBy = layerLatLngs[item + 1].lng;

        // уравнение прямой по двум точкам
        // Общий вид итого уравнения прямой Ax + By + C = 0;
        // Для нахождения уравнения прямой использовалась формула - "(y1 - y2) * x + (x2 - x1) * y + (x1*y2 - x2y1) = 0"

        // const equation = '(' + (pointAy - pointBy) + ') * x +
        // ' + '(' + (pointBx - pointAx) + ') * y + ' + '(' + ((pointAx * pointBy) - (pointBx * pointAy)) + ')';

        // После получения уравнения прямой, мы можем получить расстояние от точки нажатия на трек до полученной прямой
        // Расстояние вычисляется по формуле d = |A*Mx + B*My + C| / sqrt((A*A) + (B*B))

        // значение параметра A
        const equationA = pointAy - pointBy;
        // значение параметра B
        const equationB = pointBx - pointAx;
        // значение параметра C
        const equationC = (pointAx * pointBy) - (pointBx * pointAy);

        // результат вычисления расстояния от точки до прямой
        let resultDistanceFromTrackToPoint = null;

        if (equationA === 0 && equationB === 0 && equationC === 0) {
          resultDistanceFromTrackToPoint = Math.sqrt(Math.pow(currentLat - pointAx, 2) + Math.pow(currentLon - pointAy, 2));
        } else {
          const sqrPoints_O_A = Math.pow(currentLat - pointAx, 2) + Math.pow(currentLon - pointAy, 2);
          const sqrPoints_O_B = Math.pow(currentLat - pointBx, 2) + Math.pow(currentLon - pointBy, 2);
          const sqrPoints_A_B = Math.pow(pointBx - pointAx, 2) + Math.pow(pointBy - pointAy, 2);
          const S = Math.abs((currentLat - pointBx) * (pointAy - pointBy) - (pointAx - pointBx) * (currentLon - pointBy)) / 2;
          const H = (2 * S) / Math.sqrt(sqrPoints_A_B);

          if (((sqrPoints_O_A + sqrPoints_A_B) < sqrPoints_O_B) || ((sqrPoints_O_B + sqrPoints_A_B) < sqrPoints_O_A)) {
            if (sqrPoints_O_A < sqrPoints_O_B) {
              resultDistanceFromTrackToPoint = Math.sqrt(sqrPoints_O_A);
            } else {
              resultDistanceFromTrackToPoint = Math.sqrt(sqrPoints_O_B);
            }
          } else {
            resultDistanceFromTrackToPoint = H;
          }
        }

        if (tempDistance === undefined) {
          tempDistance = resultDistanceFromTrackToPoint;
          resultCoords[0] = pointA;
          resultCoords[1] = pointB;
        } else {
          if (resultDistanceFromTrackToPoint < tempDistance) {
            tempDistance = resultDistanceFromTrackToPoint;
            resultCoords[0] = pointA;
            resultCoords[1] = pointB;
          }
        }

      }

    }

    return resultCoords;
  }

  static getNearestCoordsOfNearestTrack(currentLat, currentLon, resultCoords) {

    let tempDistance;
    let resultCoord;

    for (const item of resultCoords) {

      const lat = item.lat;
      const lon = item.lng;

      if (lat !== undefined && lon !== undefined) {

        const result = Math.sqrt(Math.pow(currentLat - lat, 2) + Math.pow(currentLon - lon, 2));

        if (tempDistance === undefined) {
          tempDistance = result;
          resultCoord = item;
        } else {
          if (result < tempDistance) {
            tempDistance = result;
            resultCoord = item;
          }
        }

      }
    }

    return resultCoord;
  }
}
